// CSS
import "./css/index.css";

// Initialize Alpine.js first (synchronous as it's needed for the page structure)
import "./js/alpinejs.js";

// Initialize scroll manager first (foundational) - Performance issue change to GSAP
/* import "./js/scroll-manager.js"; */

// Async initialization function to prevent flash
async function initializeApp() {
	try {
		// Load and initialize critical modules first after DOM is ready
		const [
			{ initSliders },
			{
				/* gsap-animations auto-initializes with scroll-to-top included */
			},
			{ initPageNavigation },
			{ initNavFadeController },
			{ initGetHeaderHeight },
		] = await Promise.all([
			import("./js/slider.js"),
			import("./js/gsap-animations.js"),
			import("./js/page-nav.js"),
			import("./js/nav-fade-controller.js"),
			import("./js/get-header-height.js"),
		]);

		// Initialize all modules in controlled order
		initSliders();
		initPageNavigation();
		initNavFadeController();
		initGetHeaderHeight();

		// Mark as loaded to show content
		document.body.classList.remove("js-loading");
		document.body.classList.add("js-loaded");
	} catch (error) {
		console.error("Failed to initialize app:", error);
		// Show content even if there's an error to prevent blank page
		document.body.classList.remove("js-loading");
		document.body.classList.add("js-loaded");
	}
}
document.addEventListener("DOMContentLoaded", initializeApp);

if (import.meta.hot) {
	import.meta.hot.accept(() => {
		console.log("HMR");
	});
}
